// import router from 'vue-router'
import axios from 'axios';

const actions = {
    getAll: (_, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const company_id = payload.company_id;

        let url = process.env.VUE_APP_HOUR_APP_BACKEND + '/api/shifts';
        return axios.get(url, {
            params: {
                firebaseIdToken: ApiClient.token,
                departments: departments,
                company_id: company_id
            }
        }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    updateShift: (_, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const shift = payload.shift;

        return axios.patch(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/shift/' + shift.id,
            { ...shift },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    createShift: (_, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const shift = payload.shift;

        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/shift',
            { ...shift },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    deleteShift: (_, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const shiftId = payload.shiftId;

        return axios.delete(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/shift/' + shiftId,
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    syncShifts: (_, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.put(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/shifts/batch',
            {
                organization_id: payload.organization_id,
                shifts: payload.shifts
            },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    }
}

export default actions
